import React from 'react';
import { Accordion, Row, Col, Breadcrumb } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { selector as groupApi } from '../../deviceManagement/groupSlice';
import { makeGroups, makeTimeStamp } from './utils';
import AlertTemplate from './AlertTemplate';
import { IApprovalAlertData } from '../../../common/types/alertsTypes';
interface AlertApprovalAccordianProps {
  item: IApprovalAlertData;
}
const alertsApprovalAccordian: React.FC<AlertApprovalAccordianProps> = ({
  item,
}) => {
  const { endTime, startTime } = item;
  const { groups, templateId } = item?.subscriptionDetails ?? {};
  const { VALUE: alertMessage } = item?.dasDetails[0]?.json?.EAS?.TRANSLATION;
  const { VALUE: alertShortName } = item?.dasDetails[0]?.json?.EAS?.TYPE;
  const { HEADLINE } = item?.dasDetails[0]?.json?.EAS;
  const alertName = HEADLINE.split(' ').splice(0, 3).join(' ');
  const startDate = makeTimeStamp(startTime);
  const endDate = makeTimeStamp(endTime);

  const groupIdToHierarchyMap: Record<string, string> =
    useSelector(groupApi).groupIdToHierarchyMap;
  const commaSeparatedGroups = makeGroups(groupIdToHierarchyMap, groups);

  return (
    <div>
      <Accordion>
        <Accordion.Item eventKey='0'>
          <Accordion.Header>
            <div className='alertsApprovalAccordion_header'>
              <div className='font-600 accordion-heading'>
                Digital Alert Systems
              </div>
              <div className='heading-text'>
                {alertName} ({alertShortName})
              </div>
              <div className='heading-text'>
                <span className='font-600'>Start Time:&nbsp;</span>
                {startDate}
              </div>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <div className='alertsApprovalAccordion_body'>
              <Row>
                <Col sm={2}>
                  <div className='alertsApprovalAccordion_label'>Groups:</div>
                </Col>
                <Col sm={10}>
                  <div className='alertsApprovalAccordion_content'>
                    <Breadcrumb>
                      <Breadcrumb.Item active>
                        {commaSeparatedGroups}
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col sm={2}>
                  <div className='alertsApprovalAccordion_label'>
                    Alert Message:
                  </div>
                </Col>
                <Col sm={10}>
                  <div className='alertsApprovalAccordion_content'>
                    <p>{alertMessage}</p>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col sm={2}>
                  <div className='alertsApprovalAccordion_label'>
                    Start Date & Time:
                  </div>
                </Col>
                <Col sm={10}>
                  <div className='alertsApprovalAccordion_content'>
                    <p>{startDate}</p>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col sm={2}>
                  <div className='alertsApprovalAccordion_label'>
                    End Date & Time:
                  </div>
                </Col>
                <Col sm={10}>
                  <div className='alertsApprovalAccordion_content'>
                    <p>{endDate}</p>
                  </div>
                </Col>
              </Row>

              {templateId === '1' ? <AlertTemplate alertType='Ticker' /> : null}
              {templateId === '2' ? (
                <AlertTemplate alertType='Overlay' />
              ) : null}
              {templateId === '3' ? (
                <AlertTemplate alertType='Fullscreen' />
              ) : null}
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default alertsApprovalAccordian;
